import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent, StripeCardCvcElementOptions } from '@stripe/stripe-js';
import React, { FC, memo, useState } from 'react';
import { getCardFieldOptions } from '../../constants';
import ErrorMessage from '../errorMessage';
import s from './index.module.scss';
import classnames from 'classnames';
import locales from '../../../../../../../../../../content.json';

// import cvc from './img/cvc.png';

type Props = {
  className?: string;
  options?: StripeCardCvcElementOptions;
  onChange?: (event: StripeCardCvcElementChangeEvent) => void;
};

const CardCvc: FC<Props> = props => {
  const { className, onChange, options = getCardFieldOptions() } = props;
  const [empty, setEmpty] = useState<boolean | undefined>(false);
  const [error, setError] = useState<string | undefined>();

  const handleChange = (event: StripeCardCvcElementChangeEvent) => {
    onChange && onChange(event);
    setError(event.error?.message);
  };

  return (
    <>
      <div className={classnames(className, s.cvc, { [s.empty]: empty })}>
        <CardCvcElement onChange={handleChange} options={options} onFocus={() => setEmpty(true)} onBlur={() => setEmpty(false)}/>
        {/* <img data-test="card-brand" className={s.cvc__img} src={cvc} alt="cvc" /> */}
        {empty && (
          <span className={s.cvc_title}>{locales[window.userLang].payment_text_107}</span>
        )}
      </div>
      {error && <ErrorMessage error={error} />}
    </>
  );
};

export default memo(CardCvc);
